import React from 'react';

import Util from '$utilities';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {React.FC<>}
 */
const ErrorPage = (props) => {
    const status = Util.try(() => props.err.status) || 500;

    const page = props?.data?.page;
    let message = '';

    switch(status) {
        case 404:
            message = '404 - Page not found.';
            break;

        default:
            message = 'Sorry, something went wrong.';
    }

    const title = Util.try(() => page.title) || message;

    return (
        <main id='main-content'>
            <h1>
                {title}
            </h1>
        </main>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ErrorPage;
